import { Box, Button, Typography } from "@mui/material";
import React from "react";
import theme from "../../../../utils/theme";
import "../../ActivateSubscription.css";
const BasicPlan = () => {
  return (
    <div
      style={{
        marginTop: "5rem",
        width: "100%",
        border: "solid 3px #B1E2DB",
        borderRadius: "20px",
        padding: "10px 10px 10px 0px",
        }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src="/images/RewardBadge2.png" alt="not found" />
        <h4>Basic (Service) Plan</h4>
      </div>

      <div
        style={{
          width: "50%",
          display: "flex",
          paddingLeft:"15px"
        }}
      >
        <Button
          variant="contained"
          style={{
            backgroundColor: theme.palette.primary.main,
            borderRadius: "10px",
            marginTop: "1rem",
          }}
        >
          Benefits
        </Button>
      </div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            flexDirection: "column",
            marginTop: "1rem",
            paddingLeft: "1rem",
          }}
        >
          <Box className="Box-container">
            {" "}
            <Box className="listing"></Box>Shop Name
          </Box>
          <Box className="Box-container">
            {" "}
            <Box className="listing"></Box>Place
          </Box>
          <Box className="Box-container">
            {" "}
            <Box className="listing"></Box>Shop Image
          </Box>
          <Box className="Box-container">
            {" "}
            <Box className="listing"></Box>Category
          </Box>
          <Box className="Box-container">
            {" "}
            <Box className="listing"></Box>Phone number
          </Box>
          <Box className="Box-container">
            {" "}
            <Box className="listing"></Box>
            WhatsApp
          </Box>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Box className="typo_container">
            <Typography className="typo_box_old">
              ₹ <Typography className="typo_old">1600 </Typography>
            </Typography>
            <Typography className="typo_box">
              ₹ <Typography  className="typo-new">800 </Typography>
            </Typography>
          </Box>
        
          <Button
            disabled
            variant="contained"
            style={{
              backgroundColor: theme.palette.primary.main,
              borderRadius: "10px",
              marginTop: "1rem",
              color: "#fff",
              textTransform: "none",
            }}
          >
            Activate Now
          </Button>
        </div>
      </Box>
    </div>
  );
};

export default BasicPlan;
